// @flow
import React from 'react';

import { withTheme } from '@material-ui/core/styles';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withTranslation } from 'react-i18next';
import { ListItemIcon, List, Collapse, withStyles } from '@material-ui/core';
import Toggle from 'react-toggled';
import { EmptyIcon, styles } from './SidebarHelpers';

type Props = {
  t: Function,
  speechLang: string,
  availableLangs: any,
  setLangSelected: Function,
  classes: Object,
};

type State = {};

class LangSelector extends React.Component<Props, State> {
  selectLang = lang => {
    const { setLangSelected } = this.props;
    localStorage.setItem('speechLang', lang);
    setLangSelected(lang);
  };

  render() {
    const { speechLang, availableLangs, classes, t } = this.props;
    const langs = [];
    Object.keys(availableLangs).forEach(key => {
      langs.push({ value: availableLangs[key].languageCode, key });
    });

    const lang = langs.find(l => l.value === speechLang) || {};
    return (
      <Toggle>
        {({ on, getTogglerProps, setOff }) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <ListItem key="lang_selected" button {...getTogglerProps()}>
              <ListItemIcon>
                <i className="material-icons">sms</i>
              </ListItemIcon>
              <ListItemText style={{ paddingRight: 0 }}>
                {t('micSettings.chooseLang')}
                <br />
                <b>{lang.key}</b>
              </ListItemText>
              <ListItemIcon style={{ marginRight: 0 }}>
                <i className="material-icons" style={{ marginLeft: 0 }}>
                  {on ? 'expand_less' : 'expand_more'}
                </i>
              </ListItemIcon>
            </ListItem>
            <Collapse in={on} timeout="auto" unmountOnExit>
              <List>
                {langs.map(lang_ => (
                  <ListItem
                    key={lang_.value}
                    button
                    style={{
                      display: lang === lang_ ? 'none' : undefined,
                    }}
                  >
                    <EmptyIcon />
                    <ListItemText
                      classes={{ root: classes.listItemText }}
                      onClick={() => {
                        this.selectLang(lang_.value);
                        setOff();
                      }}
                      primary={lang_.key}
                    />
                  </ListItem>
                ))}
              </List>
            </Collapse>
          </div>
        )}
      </Toggle>
    );
  }
}

export default withStyles(styles)(withTranslation()(withTheme(LangSelector)));
